import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { ProductGroupService } from "../service/product-group.service"
import { DataProviderService } from "../service/data-provider.service"
import { environment } from "../../environments/environment";

@Component({
    selector: 'app-product',
    standalone: true,
    imports: [],
    templateUrl: './product.component.html',
    styleUrl: './product.component.scss'
})
export class ProductComponent implements OnInit {
    products: any;
    fileUrl = environment.FILE_URL;

    constructor(private productGroupService: ProductGroupService,
                private router: Router,
                private dataProviderService: DataProviderService) {
    }

    async ngOnInit() {
        await this.fetchData();
    }

    async fetchData() {
        try {
            let res = await this.productGroupService.query({
                find: {
                    active:true
                },
                deep: "mpg_tax_objid"
            });
            this.products = res.map((e: any) => {
                const tax = e.mpg_tax_objid || {}; // ✅ fallback if undefined
                return {
                    _id: e._id,
                    productName: e.mpg_productGroupName_str,
                    productGroupCategory: e.mpg_productGroupCategory_str,
                    productImageArr: e.mpg_productGroupImg_arr,
                    productDescription: e.mpg_description_str,
                    taxValue: tax.mpt_rate_num || null,   // ✅ safe access
                    taxName: tax.mpt_taxName_str || null, // ✅ safe access
                };
            });

            if (this.products?.length) {
                for (let item of this.products) {
                    if (item.productImageArr?.length) {
                        const uploadPath = item.productImageArr[0]?.uploadPath;
                        if (uploadPath) {
                            item.fileUrl = `${this.fileUrl}${uploadPath}`;
                        }
                    }
                }
            }

        } catch (e) {
            console.error("fetchData error:", e);
        }
    }

    navigateToAddOrder(item: any) {
        this.dataProviderService.setDataForAddOrder(item.productDescription, item._id, item.taxName, item.taxValue, item.productName, item.productGroupCategory)
        return this.router.navigate(['/add-order'])
    }
}
